/* Enhancements are delegated so Theme Editor section reloads keep working. */
function activateStudioTab(container, selected, focus = false) {
  container.querySelectorAll('[role="tab"]').forEach((tab) => {
    const active = tab === selected;
    tab.setAttribute('aria-selected', String(active));
    tab.tabIndex = active ? 0 : -1;
    const panel = document.getElementById(tab.getAttribute('aria-controls'));
    if (panel) panel.hidden = !active;
  });
  if (focus) selected.focus();
}

function initStudioTabs(root = document) {
  root.querySelectorAll('[data-studio-tabs]').forEach((container) => {
    if (container.dataset.ready) return;
    const first = container.querySelector('[role="tab"]');
    if (!first) return;
    container.dataset.ready = 'true';
    container.querySelector('[role="tablist"]').hidden = false;
    activateStudioTab(container, first);
  });
}
initStudioTabs();
function updateReadingProgress() {
  const progress = document.querySelector('[data-reading-progress]');
  if (!progress) return;
  const distance = document.documentElement.scrollHeight - window.innerHeight;
  progress.value = distance > 0 ? Math.min(100, window.scrollY / distance * 100) : 100;
}
document.addEventListener('scroll', updateReadingProgress, {passive: true});
window.addEventListener('resize', updateReadingProgress);
updateReadingProgress();
document.addEventListener('shopify:section:load', (event) => initStudioTabs(event.target));
document.addEventListener('shopify:block:select', (event) => {
  const panel = event.target.closest('[role="tabpanel"]');
  if (panel) {
    const container = panel.closest('[data-studio-tabs]');
    const tab = document.getElementById(panel.getAttribute('aria-labelledby'));
    if (container && tab) activateStudioTab(container, tab);
  }
});
document.addEventListener('keydown', (event) => {
  if (!(event.target instanceof Element) || !event.target.matches('.studio-tab-list [role="tab"]')) return;
  const container = event.target.closest('[data-studio-tabs]');
  const tabs = [...container.querySelectorAll('[role="tab"]')];
  const index = tabs.indexOf(event.target);
  let next;
  if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
  if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
  if (event.key === 'Home') next = 0;
  if (event.key === 'End') next = tabs.length - 1;
  if (next === undefined) return;
  event.preventDefault();
  activateStudioTab(container, tabs[next], true);
});
document.addEventListener('input', (event) => {
  if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-compare-range]')) return;
  event.target.closest('[data-compare]')?.style.setProperty('--reveal', `${event.target.value}%`);
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const tab = event.target.closest('.studio-tab-list [role="tab"]');
  if (tab) activateStudioTab(tab.closest('[data-studio-tabs]'), tab);
  const pause = event.target.closest('[data-strip-pause]');
  if (pause) {
    const paused = pause.getAttribute('aria-pressed') !== 'true';
    pause.setAttribute('aria-pressed', String(paused));
    pause.closest('.studio-image-strip').classList.toggle('is-paused', paused);
    pause.textContent = paused ? 'Play image strip' : 'Pause image strip';
  }
  const control = event.target.closest('[data-studio-scroll]');
  if (control) {
    const rail = document.getElementById(control.getAttribute('aria-controls'));
    if (rail) rail.scrollBy({left: rail.clientWidth * Number(control.dataset.studioScroll), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }
  if (event.target.closest('[data-scroll-top]')) window.scrollTo({top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});
